import { useCallback, useEffect, useState } from 'react';
import type { ApiResponse } from '@/types/api.type';
import { useAuth } from '@/contexts/auth-context';
import api from '@/lib/api';

// Generic interfaces for reusable data hook
interface UseDataConfig {
  endpoint: string;
}

/**
 * Generic reusable data hook for CRUD operations
 * @param config - Configuration object with endpoint and optional queryKey
 * @param initialList - Initial data list (optional)
 * @param searchData - Search parameters (optional)
 * @returns Hook return object with data and CRUD operations
 */
export const usePatch = (config: UseDataConfig) => {
  const { entity } = useAuth();

  const { endpoint } = config;

  const patchItem = async (uuid: string, itemData: any) => {
    if (!entity?.slug) throw new Error('Entity slug is required');

    try {
      await api.patch(`/entities/${entity.slug}/erp/${endpoint}/${uuid}/`, itemData);
    } catch (error: any) {
      return;
    }
  };

  return {
    patchItem
  };
};
